// extracted by mini-css-extract-plugin
export default {"launchContainer":"Launch_launchContainer__TtQPB","launchText":"Launch_launchText__TONHv","launchingGif":"Launch_launchingGif__YGwTt"};